// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const borderWidths = {
  borderless: '0px',
  regular: '1px',
  medium: '2px',
  fat: '4px'
} as const;

export default borderWidths;
